

































import { Component, Vue } from "vue-property-decorator";

import { AccountService } from "@/core/services";
import { ssoEndpoints } from "@/core/constants";
import PrivacyPolicyCpt from "./PrivacyPolicyCpt.vue";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    PrivacyPolicyCpt,
  },
})
export default class AuthStatusCpt extends AppVue {
  isPrivacyPolicyVisible = false;
  isAuthenticated = false;
  userName = "";

  created() {
    this.setData();
    this.$eventHub.$on("USER_UPDATED", () => this.setData());
  }

  async loginAsDifferentUser(loginType: string) {
    switch (loginType) {
      case "IMI":
        await AccountService.loginAsImi();
        break;
      case "EI":
        await AccountService.loginAsEi();
        break;
      case "USER":
        await AccountService.loginAsUser();
        break;
    }

    this.$router.push("/home");
    this.$router.go(0);
  }

  async logout() {
    await AccountService.logout();

    this.notify("Success", "You are now logged out.", "success");

    this.$router.push("/login");
  }

  openPrivacyPolicy() {
    this.isPrivacyPolicyVisible = true;
  }

  private setData() {
    this.isAuthenticated = this.$auth.isAuthenticated();
    this.userName = this.isAuthenticated ? this.$auth.getPayload().userName : "";
  }
}
